import { useGetAlertNoticesMutation } from '@frontend/redux';
import withNoticeList from '../Home/withNoticeList';

const AlertNotices = withNoticeList(
    useGetAlertNoticesMutation,
);

export default AlertNotices;